import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=baee027c&scoped=true"
import script from "./DetailModal.vue?vue&type=script&lang=js"
export * from "./DetailModal.vue?vue&type=script&lang=js"
import style0 from "./DetailModal.vue?vue&type=style&index=0&id=baee027c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baee027c",
  null
  
)

export default component.exports